// extracted by mini-css-extract-plugin
export default {"price_area":"Price_price_area__kTuX2","contents":"Price_contents__5mYaM"};